import { Column, ColumnCenter, Row, RowCenter } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

import { ReactComponent as DaoRewardsSvg } from 'assets/svgs/dao_nav_rewards.svg'
import { ReactComponent as DaoVolumeSvg } from 'assets/svgs/dao_volume.svg'
import { ReactComponent as DaoStatSvg } from 'assets/svgs/dao_stat.svg'
import { ReactComponent as DaoWebSvg } from 'assets/svgs/dao_web.svg'
import { ReactComponent as DaoArrowRightSvg } from 'assets/svgs/dao_arrow_right.svg'

import { ReactComponent as DaoStakingSvg } from 'assets/svgs/dao_nav_staking.svg'
import { ReactComponent as DaoParticipateSvg } from 'assets/svgs/dao_nav_participate.svg'

import SvgCom from "components/SvgCom"
import useDao from "hooks/useDao"
import { formatNum } from "utils"
import { useCallback, useEffect, useState } from "react"
import { getDashboardInfo } from "services/daoServices"
import { DashboardInfoProps } from "types/baseType"


interface Props {
    onOpenStakeWin?: () => void
    onOpenStaking?: () => void
}

const DashboardCom = ({onOpenStakeWin, onOpenStaking}: Props) => {
    const { totalStaking, userVoting, totalStakedXCHNG, yourPower, totalVXCHNGStaked } = useDao()
    const [dashboardInfo, setDashboardInfo] = useState<DashboardInfoProps>({
        totalVolume: 0,
        totalRevenue: 0,
        curQuarterRevenue: 0,
        curQuarterVolume: 0,
        preQuarterRevenue: 0,
        preQuarterVolume: 0,
    })

    const fnGetDashboardInfo = useCallback(async () => {
        const result = await getDashboardInfo()
        if(result) {
            setDashboardInfo(result)
        }
    }, [])

    useEffect(() => {
        fnGetDashboardInfo()
    }, [fnGetDashboardInfo])

    useEffect(() => {
        const timer = setInterval(async () => {
            await fnGetDashboardInfo()
        }, 10000)
        return () => {
            clearInterval(timer)
        }
    }, [fnGetDashboardInfo])
    

    return <div>
        <Row $justifyContent="space-between">
            <ColumnCard>
                <CardStyle1 $backgroundColor="#77E4B5 !important;">
                    <ImgBoxWrap $backgroundColor="#ffffff !important;">
                        <SvgComWrap Svg={DaoRewardsSvg} size="18"></SvgComWrap>
                    </ImgBoxWrap>
                    <Column $ml="12px">
                        <StyledContainer $fontSize="14px" $fontWeight4 $lineHeight="1">Total revenue</StyledContainer>
                        <StyledContainer $fontSize="18px" $fontWeight6 $lineHeight="1" $mt="8px" $mb="8px">${formatNum(dashboardInfo?.totalRevenue, 2)}</StyledContainer>
                        <StyledContainer $fontSize="12px" $fontWeight4 $lineHeight="1">Cumulative revenue since DAO launch</StyledContainer>
                    </Column>
                </CardStyle1>
                <StyledContainer $height="10px"></StyledContainer>
                <CardStyle1>
                    <ImgBoxWrap>
                        <SvgComWrap Svg={DaoRewardsSvg} size="18"></SvgComWrap>
                    </ImgBoxWrap>
                    <Column $ml="12px">
                        <StyledContainer $fontSize="14px" $fontWeight4 $lineHeight="1">Current quarter revenue</StyledContainer>
                        <StyledContainer $fontSize="18px" $fontWeight6 $lineHeight="1" $mt="8px" $mb="8px">${formatNum(dashboardInfo?.curQuarterRevenue, 2)}</StyledContainer>
                        <StyledContainer $fontSize="12px" $fontWeight5 $lineHeight="1">Quarter currently in progress</StyledContainer>
                    </Column>
                </CardStyle1>
                <LineWrap></LineWrap>
                <CardStyle1>
                    <ImgBoxWrap>
                        <SvgComWrap Svg={DaoRewardsSvg} size="18"></SvgComWrap>
                    </ImgBoxWrap>
                    <Column $ml="12px">
                        <StyledContainer $fontSize="14px" $fontWeight4 $lineHeight="1">Previous quarter revenue</StyledContainer>
                        <StyledContainer $fontSize="18px" $fontWeight6 $lineHeight="1" $mt="8px" $mb="8px">${formatNum(dashboardInfo?.preQuarterRevenue, 2)}</StyledContainer>
                        <StyledContainer $fontSize="12px" $fontWeight5 $lineHeight="1">Total revenue for the past quarter</StyledContainer>
                    </Column>
                </CardStyle1>
            </ColumnCard>
            <ColumnCard>
                <CardStyle1 $backgroundColor="#77E4B5 !important;">
                    <ImgBoxWrap $backgroundColor="#ffffff !important;">
                        <SvgComWrap Svg={DaoVolumeSvg} size="18"></SvgComWrap>
                    </ImgBoxWrap>
                    <Column $ml="12px">
                        <StyledContainer $fontSize="14px" $fontWeight4 $lineHeight="1">Total trading volume</StyledContainer>
                        <StyledContainer $fontSize="18px" $fontWeight6 $lineHeight="1" $mt="8px" $mb="8px">${formatNum(dashboardInfo?.totalVolume, 2)}</StyledContainer>
                        <StyledContainer $fontSize="12px" $fontWeight4 $lineHeight="1">Cumulative volume since DAO launch</StyledContainer>
                    </Column>
                </CardStyle1>
                <StyledContainer $height="10px"></StyledContainer>
                <CardStyle1>
                    <ImgBoxWrap>
                        <SvgComWrap Svg={DaoVolumeSvg} size="18"></SvgComWrap>
                    </ImgBoxWrap>
                    <Column $ml="12px">
                        <StyledContainer $fontSize="14px" $fontWeight4 $lineHeight="1">Current quarter volume</StyledContainer>
                        <StyledContainer $fontSize="18px" $fontWeight6 $lineHeight="1" $mt="8px" $mb="8px">${formatNum(dashboardInfo?.curQuarterVolume, 2)}</StyledContainer>
                        <StyledContainer $fontSize="12px" $fontWeight5 $lineHeight="1">Quarter currently in progress</StyledContainer>
                    </Column>
                </CardStyle1>
                <LineWrap></LineWrap>
                <CardStyle1>
                    <ImgBoxWrap>
                        <SvgComWrap Svg={DaoVolumeSvg} size="18"></SvgComWrap>
                    </ImgBoxWrap>
                    <Column $ml="12px">
                        <StyledContainer $fontSize="14px" $fontWeight4 $lineHeight="1">Previous quarter volume</StyledContainer>
                        <StyledContainer $fontSize="18px" $fontWeight6 $lineHeight="1" $mt="8px" $mb="8px">${formatNum(dashboardInfo?.preQuarterVolume, 2)}</StyledContainer>
                        <StyledContainer $fontSize="12px" $fontWeight5 $lineHeight="1">Total volume for the past quarter</StyledContainer>
                    </Column>
                </CardStyle1>
            </ColumnCard>
            <ColumnCard $flex $flexDirection="column" $justifyContent="center" $alignItems="center">
                <ColumnCenter>
                    <SvgCom Svg={DaoStatSvg} size="40"></SvgCom>
                    <StyledContainer $height="20px"></StyledContainer>
                    <StyledContainer $fontSize="20px" $fontWeight6 $lineHeight="20px">{yourPower}</StyledContainer>
                    <StyledContainer $height="8px"></StyledContainer>
                    <StyledContainer $fontSize="16px" $fontWeight5 $lineHeight="1">Your power impact</StyledContainer>
                    <StyledContainer $height="8px"></StyledContainer>
                    <StyledContainer $fontSize="12px" $width="65%" $textAlign="center" $fontWeight5 $lineHeight="14px" $color="#767A7F">This represents your voting power's impact within the entire DAO ecosystem</StyledContainer>
                    <StyledContainer $height="8px"></StyledContainer>
                    <StyledContainer $fontSize="14px" $fontWeight6 $lineHeight="1" $color="#4D1DF7" onClick={onOpenStakeWin} $pointer>Boost your impact</StyledContainer>
                </ColumnCenter>
            </ColumnCard>
        </Row>
        <StyledContainer $height="10px"></StyledContainer>
        <Row $justifyContent="space-between">
            <CardStyle3 onClick={onOpenStaking}>
                <ImgBoxWrap $width="40px !important;" $height="40px !important;">
                    <SvgComWrap Svg={DaoStakingSvg} size="22.5"></SvgComWrap>
                </ImgBoxWrap>
                <Column $ml="20px">
                    <StyledContainer $fontSize="14px" $lineHeight="1" $roobertRegular>Total ecosystem staked balance</StyledContainer>
                    <Row $mt="8px">
                        <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(totalStaking, 2)} XCHNG</StyledContainer>
                        <SvgComWrap Svg={DaoArrowRightSvg} size="12"></SvgComWrap>
                    </Row>
                    <StyledContainer $mt="16px" $fontSize="14px" $lineHeight="1" $roobertRegular>Your total staked balance</StyledContainer>
                    <Row $mt="8px">
                        <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(totalStakedXCHNG, 2)} XCHNG</StyledContainer>
                        <SvgComWrap Svg={DaoArrowRightSvg} size="12"></SvgComWrap>
                    </Row>
                </Column>
            </CardStyle3>
            <StyledContainer $width="10px"></StyledContainer>
            <CardStyle3 onClick={onOpenStaking}>
                <ImgBoxWrap $width="40px !important;" $height="40px !important;">
                    <SvgComWrap Svg={DaoParticipateSvg} size="22.5"></SvgComWrap>
                </ImgBoxWrap>
                <Column $ml="20px">
                    <StyledContainer $fontSize="14px" $lineHeight="1" $roobertRegular>Total ecosystem voting token balance</StyledContainer>
                    <Row $mt="8px">
                        <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(totalVXCHNGStaked, 2)} vXCHNG</StyledContainer>
                        <SvgComWrap Svg={DaoArrowRightSvg} size="12"></SvgComWrap>
                    </Row>
                    <StyledContainer $mt="16px" $fontSize="14px" $lineHeight="1" $roobertRegular>Your current voting token balance</StyledContainer>
                    <Row $mt="8px">
                        <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(userVoting, 2)} vXCHNG</StyledContainer>
                        <SvgComWrap Svg={DaoArrowRightSvg} size="12"></SvgComWrap>
                    </Row>
                </Column>
            </CardStyle3>
        </Row>
        {/* <Row $justifyContent="space-between">
            <CardStyle2 onClick={onOpenStaking}>
                <ImgBoxWrap>
                    <SvgComWrap Svg={DaoWebSvg} size="18"></SvgComWrap>
                </ImgBoxWrap>
                <StyledContainer $mt="12px" $fontSize="14px" $lineHeight="1" $fontWeight4>Total ecosystem staked balance</StyledContainer>
                <Row $mt="8px">
                    <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(totalStaking, 2)} XCHNG</StyledContainer>
                    <SvgComWrap Svg={DaoArrowRightSvg} size="12"></SvgComWrap>
                </Row>
            </CardStyle2>
            <CardStyle2 onClick={onOpenStaking}>
                <ImgBoxWrap>
                    <SvgComWrap Svg={DaoStakingSvg} size="18"></SvgComWrap>
                </ImgBoxWrap>
                <StyledContainer $mt="12px" $fontSize="14px" $lineHeight="1" $fontWeight4>Your total staked balance</StyledContainer>
                <Row $mt="8px">
                    <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(totalStakedXCHNG, 2)} XCHNG</StyledContainer>
                    <SvgComWrap Svg={DaoArrowRightSvg} size="12"></SvgComWrap>
                </Row>
            </CardStyle2>
            <CardStyle2 onClick={onOpenStaking}>
                <ImgBoxWrap>
                    <SvgComWrap Svg={DaoParticipateSvg} size="18"></SvgComWrap>
                </ImgBoxWrap>
                <StyledContainer $mt="12px" $fontSize="14px" $lineHeight="1" $fontWeight4>Your current voting token balance</StyledContainer>
                <Row $mt="8px">
                    <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(userVoting, 2)} vXCHNG</StyledContainer>
                    <SvgComWrap Svg={DaoArrowRightSvg} size="12"></SvgComWrap>
                </Row>
            </CardStyle2>
        </Row> */}
    </div>
}

const baseColumnStyle = () => {
    return css`
        height: 360px;
        width: 32.5%;
    `
}

const ColumnCard = styled(StyledContainer)`
    ${baseColumnStyle()}
    border: 1px solid #F2F2F2;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);
    border-radius: 9px;
    padding: 20px 0;
    box-sizing: border-box;
`

const CardStyle1 = styled(Row)`
    padding: 20px;
    border-radius: 9px;
    margin: 0 20px;
    box-sizing: border-box;
`

export const ImgBoxWrap = styled(RowCenter)`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #F2F2F2;
`

const LineWrap = styled(StyledContainer)`
    border-bottom: 1px dashed #CACCCE;
    margin: 5px 0;
`

export const SvgComWrap = styled(SvgCom)`
    rect, path {
        fill: #0a0a0a;
    }
`

export const CardStyle2 = styled(Column)`
    padding: 30px;
    border-radius: 9px;
    border: 1px solid #F2F2F2;
    box-sizing: border-box;
    width: 32.5%;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);

    cursor: pointer;
    &:hover {
        box-shadow: 0px 10px 32px -4px rgba(24, 39, 75, 0.10), 0px 6px 14px -6px rgba(24, 39, 75, 0.12);
    }
`

export const CardStyle3 = styled(Row)`
    padding: 24px 30px;
    border-radius: 9px;
    border: 1px solid #F2F2F2;
    box-sizing: border-box;
    flex: 1;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);

    cursor: pointer;
    &:hover {
        box-shadow: 0px 10px 32px -4px rgba(24, 39, 75, 0.10), 0px 6px 14px -6px rgba(24, 39, 75, 0.12);
    }
`

export default DashboardCom